<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()

const policyPath =
  locale.value === 'de-de'
    ? 'https://www.iubenda.com/api/privacy-policy/79545710'
    : 'https://www.iubenda.com/api/privacy-policy/40710267'

const { data } = await useFetch(policyPath, {
  pick: ['content'],
})

useHead({
  title: locale.value === 'de-de' ? 'Datenschutz' : 'Privacy Policy',
})

const isStylesLoaded = ref(false)

onMounted(async () => {
  await import('~/assets/css/policy-page.css')
  await nextTick()
  isStylesLoaded.value = true
})
</script>

<template>
  <div class="my-5">
    <div class="policy-page-content" :class="isStylesLoaded ? 'is-loaded' : ''">
      <div v-html="data.content" />
      <IconPreloader class="preloader" />
    </div>
  </div>
</template>

<style scoped lang="postcss">
.policy-page-content {
  position: relative;
}

.preloader {
  position: fixed;
  width: 64px;
  height: 64px;
  top: 40vh;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 11;
  transition: 300ms all ease;
  opacity: 1;
  visibility: visible;
}

.policy-page-content.is-loaded .preloader {
  opacity: 0;
  visibility: hidden;
}

.policy-page-content::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #fff;
  z-index: 10;
  opacity: 1;
  visibility: visible;
  transition: all 0.3s ease;
}

.policy-page-content.is-loaded::before {
  opacity: 0;
  visibility: hidden;
}
</style>
